import { api } from "../client";
import {
  CommissionPhaseExtraFields,
  CommissionPhaseFields,
  PartialCommissionPhaseExtraFields,
  PartialCommissionPhaseFields,
} from "../schema/CommissionPhase";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  CommissionPhaseFields,
  CommissionPhaseExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialCommissionPhaseFields,
  PartialCommissionPhaseExtraFields
>;

export const getCommissionPhases = async (config?: ApiRequestConfig) => {
  return api.get<CommissionPhaseFields, CommissionPhaseExtraFields>(
    "commission_phases",
    config
  );
};
export const getCommissionPhase = (id: number, config?: ApiRequestConfig) => {
  return api.get<CommissionPhaseFields, CommissionPhaseExtraFields>(
    `commission_phases/${id}`,
    config
  );
};

export const createCommissionPhase = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialCommissionPhaseFields,
    PartialCommissionPhaseExtraFields
  >("commission_phases", config);
};
export const updateCommissionPhase = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialCommissionPhaseFields,
    PartialCommissionPhaseExtraFields
  >(`commission_phases/${id}`, config);
};
export const deleteCommissionPhase = (id: number) => {
  return api.remove<CommissionPhaseFields, CommissionPhaseExtraFields>(
    `commission_phases/${id}`
  );
};
